const translations = {
  'ar': {
    'userNameText': 'اسم المستخدم',
    'emailText': 'البريد الالكتروني',
    'emailErrorText': 'البريد الالكتروني يجب ان يكون مثل abc@xyz.com',
    'usernameErrorText': 'الرجاء ادخال اسم المستخدم',
    'passwordText': 'كلمة المرور ',
    'passwordErrorText': 'كلمة المرور يجب ان تكون على الاقل ٦ حروف او ارقام.',
    'loginText': 'دخول',
    'rememberMeText': 'احتفظ  بدخولي',
    'showPasswordText': 'اظهر كلمة المرور',
    'forgotPwdText': 'نسيت كلمة المرور؟'
  },
  'en': {
    'userNameText': 'User Name',
    'emailText': 'Email',
    'emailErrorText': 'Email must be formatted abc@xyz.com',
    'usernameErrorText': 'Please enter your user name',
    'passwordText': 'Password',
    'passwordErrorText': 'The password must be at least 6 characters long.',
    'loginText': 'Sign In',
    'rememberMeText': 'Keep me signed in',
    'showPasswordText': 'Show/Hide password',
    'forgotPwdText': 'forgot your password?'
  },
  'chi': {
    'userNameText': '用户名',
    'emailText': '电子邮件',
    'emailErrorText': '电子邮件必须格式为 abc@xyz.com',
    'usernameErrorText': '请输入您的用户名',
    'passwordText': '密码',
    'passwordErrorText': '密码必须至少6个字符.',
    'loginText': '登录',
    'rememberMeText': '保持登录状态',
    'showPasswordText': '显示/隐藏 密码',
    'forgotPwdText': '显示/隐藏 密码'
  },
  'fr': {
    'userNameText': "Nom d'utilisateur",
    'emailText': 'Email',
    'emailErrorText': "L'email doit être formaté abc@xyz.com",
    'usernameErrorText': " S'il vous plaît entrez votre nom d'utilisateur",
    'passwordText': 'Mot de passe',
    'passwordErrorText': 'les mots de passe doivent comporter au moins 6 caractères.',
    'loginText': 'se connecter',
    'rememberMeText': 'Me garder connecté',
    'showPasswordText': 'Afficher / masquer le mot de passe',
    'forgotPwdText': 'masquer le mot de passe'
  }
}

export default translations
